import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../context/auth';
import { GET } from '../../../utils/requests';
import { getuseruri, product_uri } from '../../../uri';
import { TYPES, PRODUCT_TYPES } from '../../../utils/type';
import Paginations from '../../../components/Pagination';
import { Skeleton } from '@chakra-ui/react';
import { Empty, Tabs } from 'antd';
import OrderCard from './card';

const ImprovedOrderPage = () => {
  const { currentUser } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('1');
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ limit: 20, all: '', totalPage: '' });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const refreshData = () => {
    fetchOrders();
  };

  const fetchOrders = async () => {
    setLoading(true);
    let statusFilter;
    
    switch (activeTab) {
      case '1': statusFilter = TYPES.ALL; break;
      case '2': statusFilter = TYPES.REQUESTED; break;
      case '3': statusFilter = TYPES.APPROVED; break;
      case '5': statusFilter = TYPES.CONFIRM; break;
      default: statusFilter = TYPES.ALL;
    }

    try {
      const res = await GET(
        product_uri + `/orders?token=${currentUser}&page=${page}&status=${statusFilter}&limit=${pagination.limit}`
      );
      setData(res.data.data);
      setPagination({ ...pagination, all: res.data.all, totalPage: res.data.totalPage });
    } catch (err) {
      if (err.response?.status === 444) {
        nav("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!currentUser) {
      nav("/login");
      return;
    }
    fetchOrders();
  }, [page, activeTab, currentUser]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    setPage(1); // Reset to first page when changing tabs
  };

  const changePage = (page) => {
    setPage(page);
  };

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const tabItems = [
    { key: '1', label: 'Бүгд', children: null },
    { key: '2', label: 'Төлөгдөөгүй', children: null },
    { key: '3', label: 'Төлөгдсөн', children: null },
    { key: '5', label: 'Авсан', children: null },
  ];

  return (
    <div className="font-Roboto text-black mt-8 w-full mb-10">
      <div className="mb-4">
        <h1 className="font-bold text-md uppercase text-xl">Миний захиалгууд</h1>
        <p>My orders</p>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        type="card"
        className="order-tabs"
        items={tabItems}
      />

      <div className="mt-4">
        {loading ? (
          <div>
            <Skeleton className="h-20 w-full" rounded="xl" />
            <Skeleton className="h-20 w-full mt-2" rounded="xl" />
            <Skeleton className="h-20 w-full mt-2" rounded="xl" />
          </div>
        ) : (
          <div className="space-y-4">
            {data.length > 0 ? (
              data.map((order, index) => (
                <OrderCard key={index} order={order} refreshData={refreshData} />
              ))
            ) : (
              <div className="text-white">
                <Empty
                  description={<span className="text-white">Хоосон байна</span>}
                />
              </div>
            )}
          </div>
        )}
        
        <div className="mt-4">
          <Paginations
            initialPage={1}
            total={pagination.totalPage}
            alldata={pagination.all}
            onChange={changePage}
          />
        </div>
      </div>
    </div>
  );
};

export default ImprovedOrderPage;